export const COPY = {
  description:
    'You are not following any communities with Idea Submissions enabled.',
  redirectButton: {
    text: 'Return to My Feed',
  },
} as const;
